module.exports = __webpack_public_path__ + "static/media/bkg-gry.2cfc05f6.jpg";